import { ShieldCheck } from 'lucide-react';

import { page, type DeclarationModule } from '@/app/moduleRegistry';

/**
 * Declaration du module Gdpr : demandes RGPD, export, effacement.
 *
 * `roleRequis: 'Proprietaire'`. Repondre a une demande d'effacement engage
 * l'entreprise et detruit des donnees sans retour possible ; ce n'est pas un
 * geste de production courante. Le back verifie la meme chose — ce reglage evite
 * seulement de montrer un ecran qui repondrait 403.
 */
export const moduleGdpr: DeclarationModule = {
  id: 'gdpr',
  libelle: 'Donnees personnelles',
  icone: ShieldCheck,
  ordre: 60,
  roleRequis: 'Proprietaire',

  routes: [
    {
      chemin: 'rgpd',
      estAccueil: true,
      libelleNav: 'Donnees personnelles',
      dansParametres: true,
      composant: page(() => import('./pages/RgpdPage')),
    },
  ],
};
